import styled from 'styled-components';
import { breakpoint, text, body, heading, spacing } from '@carvana/ds-styles';

const FAQSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing['2Xl']};
  padding: ${spacing['6Xl']} ${spacing['2Xl']};
  max-width: 1272px;
  margin: 0 auto;

  @media screen and (min-width: ${breakpoint.sm}) {
    flex-direction: row;
    padding: ${spacing['7Xl']} ${spacing['3Xl']};
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    padding: ${spacing['7Xl']} ${spacing['4Xl']};
    justify-content: space-between;
    gap: 0;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing['2Xl']};
  align-items: flex-start;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    max-width: 279px;
    flex: 1 0 0;
  }
  
  @media screen and (min-width: ${breakpoint.md}) {
    max-width: 386px;
    flex-direction: column;
  }

  @media screen and (min-width: ${breakpoint.xl}) {
    max-width: 408px;
  }
`;

const FAQHeader = styled.h2`
  ${heading['2Xl']};
  color: ${text.strong};
  margin: 0;
`;

const SubText = styled.p`
  ${body.regular.sm};
  color: ${text.default};
  margin: 0;

  @media screen and (min-width: ${breakpoint.md}) {
    ${body.regular.md};
  }
`;

const FAQButtonWrapper = styled.a`
  display: block;
  width: 100%;

  button {
    width: 100%;
  }

  @media screen and (min-width: ${breakpoint.sm}) {
    width: auto;
    
    button {
      width: auto;
    }
  }
`;

const FAQAccordionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 732px;
  }

  > div:first-child {
    padding-top: 0;
  }

  p {
    ${body.regular.md};
    margin-block-start: 1em;
    margin-block-end: 1em;
  }
`;

export {
  FAQSectionWrapper,
  FAQHeader,
  FAQAccordionWrapper,
  FAQButtonWrapper,
  SubText,
  TextContainer
};
